
import { defineComponent, PropType } from 'vue'
import { View } from '@/models/view'

export default defineComponent({
  name: 'NavigationTab',
  props: {
    value: {
      type: Object as PropType<View>,
      required: true
    },
    icon: {
      type: Boolean,
      default: false
    },
    active: {
      type: Boolean
    }
  },
  emits: ['click'],
  setup (props, { emit }) {
    function handleClick () {
      emit('click', props.value)
    }

    return {
      handleClick
    }
  }
})
